// Import the real moment by subpath so the bare-`moment` alias (which points at
// the moment-with-locale wrapper that imports this file) does not loop back here.
// eslint-disable-next-line import/extensions
import moment from 'moment/moment.js';

// Derive moment options.
const options = {
  meridiem: hour => {
    if (hour < 12) {
      return 'a.m.';
    }
    return 'p.m.';
  },
  monthsShort: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
};

// Called at startup so that the formatting applied under updateLocale occur site-wide.
moment.updateLocale('en', options);
